import _ from 'lodash';
import React from 'react';

import FailsafeImg from 'components/global/application/FailsafeImg';
import { imageUrlAppendStyle } from 'contexts/link_util';

import { BrandsInfoModel } from 'types/drupal/BrandInfo';

import './BrandInfoItem.sass';

interface Props {
    item: BrandsInfoModel;
    isMobile: boolean;
    className: string;
    showAsClickableImage: boolean;
}

const BrandsInfoItem: React.StatelessComponent<Props> = ({ item, isMobile, className, showAsClickableImage }) => {
    const image_url = item.field_image ? item.field_image.file.url : '';
    const brand_link = '/brands/' + item.brand_name.value + '/' + item.default_year.value;
    const contentBreak = isMobile ? <hr /> : null;

    if (showAsClickableImage) {
        return (
            <div className={className}>
                <div className="brandsInfoItem">
                    <a href={brand_link}>
                        <div className="thumbnail">
                            <FailsafeImg
                                src={imageUrlAppendStyle(image_url, 'medium')}
                            />
                        </div>
                    </a>
                </div>
        </div>
        );
    }

    return (
        <div className={className}>
            <div className="brandsInfoItem">
                <div className="thumbnail"><a href={brand_link}><FailsafeImg src={imageUrlAppendStyle(image_url, 'medium')} /></a></div>
                <div className="content" dangerouslySetInnerHTML={{ __html: item.body.summary }} />
                <div className="link"><a href={brand_link}>View Instruments</a></div>
                </div>
            {contentBreak}
        </div>
    );
};

export default BrandsInfoItem;



// WEBPACK FOOTER //
// ./src/components/pages/brand/BrandsInfoItem.tsx